import React from 'react';
import PropTypes from 'prop-types';

import { InstagramIcon } from 'icons';
import { TwitterIcon } from 'icons';
import { Button } from 'components/Button';
import { Grid } from 'components/Grid';
import { Link } from 'components/Link';
import { Text } from 'components/Text';
import { cx } from 'utility';
import * as styles from './Header.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: '',
    navLinks: [],
    socialLinks: [],
};

function getClasses({ className }) {
    const classes = cx(
        className,
        styles['header'],
    );

    return classes || undefined;
}

function Header({
    className,
    navLinks,
    socialLinks,
}) {
    const classes = getClasses({ className });

    return (
        <header className={classes}>
            <Grid>
                <div className={styles['container']}>
                    <a href="#main-content">Skip to content</a>
                    <Link aria-label="Home" className={styles['logoLink']} emphasis="high" to={{
                        link_type: "Document",
                        type: "home_page",
                        uid: "",
                    }}>
                        <svg className={styles['logo']} viewBox="0 0 205 48" xmlns="http://www.w3.org/2000/svg">
                            <path d="M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24zM23.25 14H12v12.75L23.25 38V14zm1.5 5.625a5.625 5.625 0 1011.25 0 5.625 5.625 0 00-11.25 0z" fill="#EBFFFF"/><path d="M80.33 30.058l-6.476-5.735c2.94 0 5.95-.884 5.95-4.66 0-1.96-.597-4.899-6.356-4.899H68v15.294h2.629V24.06l6.164 5.998h3.537zm-3.178-10.395c0 1.219-.43 2.7-3.537 2.7H70.63v-5.448h2.939c3.13 0 3.584 1.553 3.584 2.748zM93.328 23.94c0-3.226-1.315-6.284-6.07-6.284-4.803 0-6.07 3.058-6.07 6.284 0 3.25 1.243 6.285 6.046 6.285 4.78 0 6.094-3.011 6.094-6.285zm-2.605 0c0 2.366-.621 4.206-3.489 4.206-2.82 0-3.44-1.888-3.44-4.206 0-2.294.62-4.205 3.464-4.205 2.892 0 3.465 1.935 3.465 4.205zM107.169 23.94c0-3.345-1.123-6.284-5.161-6.284-2.414 0-3.632.836-4.158 1.649v-6.141h-2.509v16.893h1.386l.526-1.768c.478.836 1.792 1.936 4.707 1.936 4.014 0 5.209-2.94 5.209-6.285zm-2.557 0c0 2.51-.597 4.206-3.345 4.206-2.843 0-3.44-1.697-3.44-4.23 0-2.39.477-4.11 3.368-4.11 2.82 0 3.417 1.673 3.417 4.134zM127.544 25.589c0-5.663-10.036-3.274-10.036-6.571 0-1.41 1.051-2.222 3.417-2.222 2.605 0 3.68 1.075 3.799 3.178h2.605c-.024-3.274-1.888-5.377-6.308-5.377-4.397 0-6.118 1.936-6.118 4.684.096 5.352 10.06 2.843 10.06 6.428 0 1.194-.764 2.246-3.68 2.246-3.106 0-4.11-1.458-4.181-3.37h-2.629c.048 3.441 1.864 5.64 6.882 5.64 4.803 0 6.189-2.462 6.189-4.636zM132.633 14.884c0-1.243-.717-1.553-1.817-1.553-1.147 0-1.887.31-1.887 1.553 0 1.219.74 1.53 1.887 1.53 1.1 0 1.817-.311 1.817-1.53zm-.574 15.174V17.823h-2.533v12.235h2.533zM151.416 30.058v-7.193c0-2.867-.693-5.21-4.039-5.21-2.318 0-3.441 1.028-3.799 1.889-.526-1.195-1.553-1.888-3.369-1.888-2.27 0-3.37.956-3.752 1.744l-.573-1.577h-1.386v12.235h2.556v-7.336c0-1.745.431-2.916 2.342-2.916 1.96 0 2.27 1.195 2.27 2.916v7.335h2.581v-7.335c0-1.745.406-2.916 2.318-2.916 1.959 0 2.27 1.195 2.27 2.916v7.335h2.581zM165.531 23.964c0-3.345-1.195-6.308-5.209-6.308-2.916 0-4.23 1.075-4.708 1.911l-.526-1.744h-1.385v17.014h2.509v-6.285c.525.813 1.744 1.673 4.157 1.673 4.039 0 5.162-2.916 5.162-6.26zm-2.557 0c0 2.461-.597 4.134-3.417 4.134-2.891 0-3.369-1.744-3.369-4.134 0-2.533.597-4.205 3.441-4.205 2.748 0 3.345 1.72 3.345 4.205zM178.197 26.521c0-4.588-8.507-2.963-8.507-5.329 0-.788.693-1.553 2.748-1.553 2.247 0 2.963.98 3.059 2.58h2.389c0-2.7-1.409-4.563-5.376-4.563-3.871 0-5.353 1.6-5.353 3.751 0 4.373 8.603 2.605 8.531 5.257-.048.717-.741 1.53-2.915 1.53-2.39 0-3.345-1.028-3.345-2.7h-2.509c0 3.106 1.768 4.73 5.902 4.73 3.871 0 5.376-1.91 5.376-3.703zM191.756 23.94c0-3.226-1.315-6.284-6.07-6.284-4.803 0-6.069 3.058-6.069 6.284 0 3.25 1.242 6.285 6.045 6.285 4.779 0 6.094-3.011 6.094-6.285zm-2.605 0c0 2.366-.621 4.206-3.489 4.206-2.819 0-3.441-1.888-3.441-4.206 0-2.294.622-4.205 3.465-4.205 2.892 0 3.465 1.935 3.465 4.205zM205 30.058v-6.596c0-3.465-.789-5.806-4.803-5.806-2.772 0-4.062 1.051-4.468 1.888l-.574-1.72h-1.386v12.233h2.557v-6.81c0-2.198.55-3.465 3.154-3.465 2.605 0 2.987 1.29 2.987 3.465v6.81H205z" />
                        </svg>
                    </Link>
                    <nav className={styles['nav']}>
                        {navLinks.length > 0 && (
                            <ul className={styles['navList']}>
                                <li className={styles['navItem']}>
                                    <Link className={styles['navLink']} size={1} to={{
                                        link_type: "Document",
                                        type: "home_page",
                                        uid: "",
                                    }}>
                                        <Text as="span" className={styles['navLinkIcon']} emphasis="high">🏠</Text>
                                        Home
                                    </Link>
                                </li>
                                {navLinks.map(({ nav_cta, nav_link_text, nav_link_url }, index) => {
                                    const cta = nav_cta;
                                    const linkText = nav_link_text?.text;
                                    const linkUrl = nav_link_url;

                                    return (
                                        <li className={styles['navItem']} key={`header-nav-item-${index}`}>
                                            {!cta && (
                                                <Link className={styles['navLink']} partiallyActive={true} size={1} to={linkUrl}>
                                                    <Text as="span" className={styles['navLinkIcon']} emphasis="high">
                                                        {linkText === 'Business' && (<>👝</>)}
                                                        {linkText === 'Health' && (<>🍏</>)}
                                                        {linkText === 'Newsletter' && (<>📮</>)}
                                                    </Text>
                                                    {linkText}
                                                </Link>
                                            )}
                                            {cta && (
                                                <Button className={styles['navButton']} color="secondary" showExternalIcon={false} to={linkUrl}>{linkText}</Button>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                        {socialLinks.length > 0 && (
                            <ul className={styles['navList', 'navListSocial']}>
                                {socialLinks.map(({ social_link_type, social_link_url }, index) => {
                                    const linkType = social_link_type?.text;
                                    const linkUrl = social_link_url;

                                    return (
                                        <li className={styles['navItem']} key={`social-header-nav-item-${index}`}>
                                            <Button aria-label={linkType} className={styles['navButton']} color="primary" iconOnly={true} style="outline" to={linkUrl}>
                                                {(linkType === 'Instagram') && (
                                                    <InstagramIcon />
                                                )}
                                                {(linkType === 'Twitter') && (
                                                    <TwitterIcon />
                                                )}
                                            </Button>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </nav>
                </div>
            </Grid>
        </header>
    );
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export { Header };
